import {
  FETCH_IDEAS,
  FETCH_NEW_IDEAS,
  FETCH_FAVORITED_IDEAS,
  FETCH_IDEA,
  ERROR_IDEA,
  RESET_IDEAS
} from '@/actions/actionTypes';
import {
  fetchIdeasEntries,
  fetchNewIdeasEntries,
  fetchFavoritedIdeasEntries,
  fetchIdeaEntry
} from '@/domains/contentful/idea';
import { IIdea } from '@/@types/generated/contentful';
import { AppDispatch } from '@/store/configureStore';
import _ from 'lodash';

/**
 * Action Creator
 */
export const innerFetchIdeas = (ideaList: IIdea[]) => ({
  type: FETCH_IDEAS,
  payload: {
    ideaList
  }
});

export const innerFetchNewIdeas = (ideaList: IIdea[]) => ({
  type: FETCH_NEW_IDEAS,
  payload: {
    ideaList
  }
});

export const innerFetchFavoritedIdeas = (ideaList: IIdea[]) => ({
  type: FETCH_FAVORITED_IDEAS,
  payload: {
    ideaList
  }
});

export const innerFetchIdea = (idea: IIdea) => ({
  type: FETCH_IDEA,
  payload: {
    idea
  }
});

export const innerErrorIdea = () => ({
  type: ERROR_IDEA
});

export const innerResetIdeas = () => ({
  type: RESET_IDEAS
});

/**
 * Action
 */
export const fetchIdeas = () => async (dispatch: AppDispatch) => {
  const ideaList = await fetchIdeasEntries();
  ideaList && dispatch(innerFetchIdeas(ideaList));
};

export const fetchNewIdeas = (limit: number) => async (dispatch: AppDispatch) => {
  const ideaList = await fetchNewIdeasEntries(limit);
  dispatch(innerFetchNewIdeas(ideaList));
};

export const fetchFavoritedIdeas = (favoritedList: string[]) => async (dispatch: AppDispatch) => {
  const ideaList = await fetchFavoritedIdeasEntries(favoritedList);
  dispatch(innerFetchFavoritedIdeas(ideaList));
};

export const fetchIdea = (slug?: string | string[]) => async (dispatch: AppDispatch) => {
  if (!slug || _.isArray(slug)) return;
  const idea = await fetchIdeaEntry(slug);
  if (!idea) {
    dispatch(innerErrorIdea());
    return;
  }
  dispatch(innerFetchIdea(idea));
};

export const resetIdeas = () => async (dispatch: AppDispatch) => {
  dispatch(innerResetIdeas());
};
